var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrashRect = function SvgTrashRect(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M11 6v10H3V6h8ZM9.5 0h-5l-1 1H0v2h14V1h-3.5l-1-1ZM13 4H1v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrashRect);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMSA2VjE2SDNWNkgxMVpNOS41IDBINC41TDMuNSAxSDBWM0gxNFYxSDEwLjVMOS41IDBaTTEzIDRIMVYxNkMxIDE3LjEgMS45IDE4IDMgMThIMTFDMTIuMSAxOCAxMyAxNy4xIDEzIDE2VjRaIiBmaWxsPSJjdXJyZW50Y29sb3IiLz4KPC9zdmc+Cg==";